import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({

    planInfoContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '552px',
    },

    bottomSpace: {
        marginBottom: '24px',
    },

    couponCode: {
        marginLeft: '6px',
        fontSize: '12px',
    },

});

export const useStyles = makeStyles(styles);
